import { nav } from "../../config/navigation.js";
import { state } from "../../state/workspaceStore.js";
import { sidebarIcon } from "../icons/SidebarIcon.jsx";
import { nodes, attributes } from "../common/reactHelpers.jsx";
import { notices } from "../../utils/domain/model.js";
import { esc } from "../../utils/format.js";
import { avatar } from "./ProfileAvatar.jsx";
import { breadcrumbs } from "../navigation/Breadcrumbs.jsx";
export default function Header() {
  return (
    <header className={"topbar"}>
      <div className={"mobile-brand"}>
        <button
          className={"menu-toggle"}
          data-action={"menu"}
          aria-label={"Toggle navigation"}
          aria-controls={"admin-sidebar"}
          aria-expanded={"false"}
        >
          {"\u2630"}
        </button>
        <img src={"assets/praachin-logo-white.png"} alt={"Praachin Organics"} />
      </div>
      <div className={"workspace-label"}>{"Admin workspace"}</div>
      <div className={"top-actions"}>
        <button
          className={"icon"}
          data-nav={"notifications"}
          aria-label={"Notifications"}
        >
          {"\u2667 "}
          {notices(state.db).some(
            (n) => !state.db.notificationsRead.includes(n.signature),
          ) ? (
            <span className={"ping"}></span>
          ) : (
            ""
          )}
        </button>
        <button className={"profile-header"} data-nav={"profile"}>
          <span className={"header-name"}>{esc(state.db.profile.name)}</span>
          {avatar()}
        </button>
      </div>
    </header>
  );
}
